import { z } from 'zod';

import { PlaceAnatomySchema } from '../organizations/provision-organization.schemas.js';

import { GetPlaceResponseSchema } from './get-place.schemas.js';

export const UpdatePlaceBodySchema = z.object({
  name: z.string().min(1).optional(),
  slug: z
    .string()
    .min(2)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
    .optional(),
  anatomy: PlaceAnatomySchema.partial().optional(),
});

export type UpdatePlaceBody = z.infer<typeof UpdatePlaceBodySchema>;

export const UpdatePlaceResponseSchema = GetPlaceResponseSchema;

export type UpdatePlaceResponse = z.infer<typeof UpdatePlaceResponseSchema>;
